<template>
  <div id="sign-in">
    <div class="section section--nonmember">
      <div class="columns">
        <div class="column is-half-desktop is-offset-one-quarter-desktop">
          <h1 class="subtitle">ログイン</h1>
          <SingInEmail></SingInEmail>
          <div class="content is-size-7" v-if="!isEmailConfirmed()">
            <ul>
              <li>
                パスワードを忘れた場合は
                <router-link to="/forgot-password">こちら</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingInEmail from '@/components/SignInEmail';
import { db } from '@/plugins/firebase';

export default {
  name: 'SignIn',
  components: {
    SingInEmail
  },
  mounted() {
  },
  data() {
    return {};
  },
  async created() {},
  methods: {
    async isInitialSignup(token) {
      const userDoc = await db.collection('users').doc(token).get();
      return !userDoc.exists;
    },
    isEmailConfirmed() {
      return this.$route.path === '/email-confirmed';
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  color: $white;
  text-decoration: underline;
  &:hover {
    color: $white;
    text-decoration: none;
  }
}
</style>
